import { composeEffects } from '@opengov/component-library-classic/module/module';
import { reportConfigurationEffects } from '../../common/reportConfiguration/effects';
import { selectDimensionalSummaryBlockExpandedStates } from '../../common/reportConfiguration/selectors';
import { reportConfigurationActionCreators } from '../../common/reportConfiguration/state';

export const dimensionalTableEffects = composeEffects('dimensional-table', (compose) => ({
  updateAccountSummaryBlockExpanded: compose.statefulEffect(
    selectDimensionalSummaryBlockExpandedStates,
    async (expandedRowGroups, e: { accountSummaryBlockIndex; expandedState }) => {
      if (expandedRowGroups) {
        const existingSummaryBlockRecord = expandedRowGroups.some(
          (group) => group.controlBlockIndex === e.accountSummaryBlockIndex
        );
        if ((e.expandedState && !existingSummaryBlockRecord) || (!e.expandedState && existingSummaryBlockRecord)) {
          reportConfigurationActionCreators.updateAccountSummaryExpanded({
            accountSummaryBlockIndex: e.accountSummaryBlockIndex,
            nextExpandedValue: e.expandedState
          });
        }
        reportConfigurationEffects.createReportConfigurationAndUpdateUrl();
      }
    }
  )
}));
